import { apiLeague } from "api"
import Skeleton from "components/Skeleton"
import Image from "next/legacy/image"
import { useEffect, useState } from "react"

function Rank({ id }) {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState()
  const [deVice, setDeVice] = useState("desktop")

  async function fetch() {
    setLoading(true)
    try {
      const { data, success } = await apiLeague.getRanking({
        league_id: id
      })
      if (data) {
        setRows(data?.ranks)
      }
    } catch (error) {
      console.log(error.response)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetch()
  }, [])

  function HanderColorBorder(value) {
    switch (value) {
      case 1: {
        return { borderLeft: "#2662F0 solid 4px" }
      }
      case 2: {
        return { borderLeft: "#0496FF solid 4px" }
      }
      case 3: {
        return { borderLeft: "#87BFFF solid 4px" }
      }
      case 4: {
        return { borderLeft: "#BDE0F6 solid 4px" }
      }
      case rows[0]?.team_ranks?.length - 3: {
        return { borderLeft: "#EF4035 solid 4px" }
      }
      case rows[0]?.team_ranks?.length - 2: {
        return { borderLeft: "#EF4035 solid 4px" }
      }
      case rows[0]?.team_ranks?.length - 1: {
        return { borderLeft: "#EF4035 solid 4px" }
      }
      case rows[0]?.team_ranks?.length: {
        return { borderLeft: "#EF4035 solid 4px" }
      }
      default:
        return { borderLeft: "#3A455B solid 4px" }
    }
  }

  useEffect(() => {
    if (window.innerWidth < 768) {
      setDeVice("mobile")
    } else if (window.innerWidth >= 768 && window.innerWidth < 980) {
      setDeVice("ipad")
    } else {
      setDeVice("desktop")
    }
  })

  return (
    <div>
      {loading ? (
        <Skeleton type="rank"></Skeleton>
      ) : (
        <>
          {deVice === "desktop" ? (
            <div>
              <div className="text-sm mb-4 pb-8 overflow-auto scroll__video w-[778px] m-auto">
                {rows?.length > 0 ? (
                  <>
                    {rows?.map((value, index) => {
                      return (
                        <div key={index}>
                          {value?.team_ranks?.standings_type === 2 && (
                            <div className="mb-2 font-bold mt-2">{value?.group_name}</div>
                          )}
                          {/* {rows?.length > 1 && <div className="mb-2 font-bold mt-2">{value?.group_name}</div>} */}
                          {
                            <table className="w-full">
                              <tr className="font-semibold flex items-center bg-opaque-100 text-primary-300 py-3 rounded-lg mb-1">
                                <th style={{ width: "60px" }} className=" text-center"></th>
                                <th style={{ width: "240px" }} className=" text-left">
                                  <span className="ml-2"> Club</span>
                                </th>
                                <th style={{ width: "160px" }} className=" text-center">
                                  Trận
                                </th>
                                <th style={{ width: "160px" }} className=" text-center">
                                  Hiệu số
                                </th>
                                <th style={{ width: "140px" }} className="text-center">
                                  Điểm
                                </th>
                              </tr>
                              {value.team_ranks?.map((item, k) => {
                                const { team_name, goal_difference, integral, total_count, team_rank, team_logo } = item

                                return (
                                  <tr
                                    key={k}
                                    className="flex items-center hover:bg-dark-900 py-3 mb-1 bg-dark rounded-lg"
                                    style={HanderColorBorder(team_rank)}
                                  >
                                    <td style={{ width: "60px" }} className="text-center font-medium">
                                      <span className=""></span> {team_rank}
                                    </td>
                                    <td style={{ width: "240px" }} className="font-medium flex items-center">
                                      <Image
                                        src={
                                          team_logo ||
                                          "https://stvinaprod.vtvcab.vn/76dd900f-acab-49c5-b973-d3faf3b5f4c3.png"
                                        }
                                        alt={"tttt"}
                                        width={28}
                                        height={25}
                                        className=" border text-dark-500 relative rounded-full bg-dark-500"
                                        objectFit="contain"
                                        onError={(e) => {
                                          e.target.src =
                                            "https://stvinaprod.vtvcab.vn/76dd900f-acab-49c5-b973-d3faf3b5f4c3.png"
                                        }}
                                      />
                                      <span className="ml-2">{team_name}</span>
                                    </td>
                                    <td style={{ width: "160px" }} className="text-center text-primary-300">
                                      {total_count}
                                    </td>
                                    <td style={{ width: "160px" }} className=" text-center text-primary-300">
                                      {goal_difference}
                                    </td>
                                    <td style={{ width: "140px" }} className="text-center font-medium">
                                      {integral}
                                    </td>
                                  </tr>
                                )
                              })}
                            </table>
                          }
                        </div>
                      )
                    })}
                  </>
                ) : (
                  <div className="text-center flex justify-center items-center h-full">
                    Bảng xếp hạng chưa được cập nhật
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div>
              <div className="text-xs mb-4 pb-8 overflow-auto scroll__video w-full m-auto">
                {rows?.length > 0 ? (
                  <>
                    {rows?.map((value, index) => {
                      return (
                        <div key={index}>
                          {value?.team_ranks?.standings_type === 2 && (
                            <div className="mb-2 font-bold mt-2">{value?.group_name}</div>
                          )}
                          {/* {rows?.length > 1 && <div className="mb-2 font-bold mt-2">{value?.group_name}</div>} */}
                          {
                            <table className="w-full">
                              <tr className="font-semibold flex items-center bg-opaque-100 text-primary-300 py-3 rounded-lg mb-1">
                                <th style={{ width: "10%" }} className=" text-center"></th>
                                <th style={{ width: "45%" }} className=" text-left">
                                  <span className="ml-2"> Club</span>
                                </th>
                                <th style={{ width: "15%" }} className=" text-center">
                                  Trận
                                </th>
                                <th style={{ width: "15%" }} className=" text-center">
                                  Hiệu số
                                </th>
                                <th style={{ width: "15%" }} className="text-center">
                                  Điểm
                                </th>
                              </tr>
                              {value.team_ranks?.map((item, k) => {
                                const { team_name, goal_difference, integral, total_count, team_rank, team_logo } = item

                                return (
                                  <tr
                                    key={k}
                                    className="flex items-center hover:bg-dark-900 py-3 mb-1 bg-dark rounded-lg"
                                    style={HanderColorBorder(team_rank)}
                                  >
                                    <td style={{ width: "10%" }} className="text-center font-medium">
                                      <span className=""></span> {team_rank}
                                    </td>
                                    <td style={{ width: "45%" }} className="font-medium flex items-center">
                                      <Image
                                        src={
                                          team_logo ||
                                          "https://stvinaprod.vtvcab.vn/76dd900f-acab-49c5-b973-d3faf3b5f4c3.png"
                                        }
                                        alt={"tttt"}
                                        width={28}
                                        height={25}
                                        className=" border text-dark-500 relative rounded-full bg-dark-500"
                                        objectFit="contain"
                                        onError={(e) => {
                                          e.target.src =
                                            "https://stvinaprod.vtvcab.vn/76dd900f-acab-49c5-b973-d3faf3b5f4c3.png"
                                        }}
                                      />
                                      <span className="ml-2">{team_name}</span>
                                    </td>
                                    <td style={{ width: "15%" }} className="text-center text-primary-300">
                                      {total_count}
                                    </td>
                                    <td style={{ width: "15%" }} className=" text-center text-primary-300">
                                      {goal_difference}
                                    </td>
                                    <td style={{ width: "15%" }} className="text-center font-medium">
                                      {integral}
                                    </td>
                                  </tr>
                                )
                              })}
                            </table>
                          }
                        </div>
                      )
                    })}
                  </>
                ) : (
                  <div className="text-center flex justify-center items-center h-full">
                    Bảng xếp hạng chưa được cập nhật
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}
export default Rank
